import HeaderList from "../../../components/HeaderList";
import { Link } from "react-router-dom";
import { ReactComponent as History } from "../../../assets/icons/history.svg";
import styles from "../styles/styles.module.css";
import { Drawer, message, Modal, Tabs } from "antd";
import { useCallback, useEffect, useState, useRef } from "react";
import TotalActiveOrders from "./TotalActiveOrders";
import OrderDeliveryTimeInShift from "./OrderDeliveryTimeInShift";
import OrderGluing from "./OrderGluing";
import useActiveOrdersMonitor from "../hooks/useActiveOrdersMonitor";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/user";
import {
  acceptMonitorOrder,
  assignMonitorDriver,
  cancelMonitorOrder,
  dispatchMonitorOrder,
  finishMonitorOrder,
  getBranchDrivers,
  getMonitorOrders,
  getOrderDetails,
  getOrderStats,
  resendCirebaOrder,
  sendPeyaOrder,
  transferMonitorOrder,
  updateMonitorOrder,
  updateCirebaRemoteId,
} from "../../../redux/slices/monitor";
import OrderDetail from "../../../components/OrderDetail";
import { getAllBranches, selectBranches } from "../../../redux/slices/branches";
import produce from "immer";
import {
  cancellationReasonListThunk,
  selectCancellationReasons,
} from "../../../redux/slices/cancellationReason";

const ActiveOrdersMonitorUI = () => {
  const [activeKey, setActiveKey] = useState("1");
  const dispatch = useDispatch();
  const filtersRef = useRef({});
  const todayFiltersRef = useRef({});
  const queuedFiltersRef = useRef({});
  const [loadingOrder, handleLoadingOrder] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [todayLoadingTable, setTodayLoadingTable] = useState(false);
  const [queuedLoadingTable, setQueuedLoadingTable] = useState(false);
  const [orderDetail, handleOrderDetail] = useState({});
  const [modalOrder, handleModalOrder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [todayCurrentPage, setTodayCurrentPage] = useState(1);
  const [todayPageSize, setTodayPageSize] = useState(10);
  const [queuedCurrentPage, setQueuedCurrentPage] = useState(1);
  const [queuedPageSize, setQueuedPageSize] = useState(10);
  const [, setOrdersTotal] = useState(0);
  const [tableFilters, setTableFilters] = useState({});
  const [todayTableFilters, setTodayTableFilters] = useState({});
  const [queuedTableFilters, setQueuedTableFilters] = useState({});
  const [, handleModalDriverConfirm] = useState(false);
  const reasons = useSelector(selectCancellationReasons);
  const branches = useSelector(selectBranches);
  const {
    activeOrders,
    todayOrders,
    queuedOrders,
    getActiveOrders,
    getTodayOrders,
    getQueuedOrders,
  } = useActiveOrdersMonitor();
  const user = useSelector(selectUser);
  const isAdmin = user.admin;

  useEffect(() => {
    dispatch(getAllBranches(null, true));
    dispatch(cancellationReasonListThunk());
    getDataOrdersHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataOrdersHandler = async () => {
    setLoadingTable(true);
    setTodayLoadingTable(true);
    setQueuedLoadingTable(true);

    try {
      await Promise.all([
        getActiveOrders({
          user: user.id,
          isAdmin,
          current: currentPage,
          pageSize: pageSize,
          filters: tableFilters,
        }),
        getTodayOrders({
          user: user.id,
          isAdmin,
          current: todayCurrentPage,
          pageSize: todayPageSize,
          filters: todayTableFilters,
        }),
        getQueuedOrders({
          user: user.id,
          isAdmin,
          current: queuedCurrentPage,
          pageSize: queuedPageSize,
          filters: queuedTableFilters,
        }),
      ]);
    } finally {
      setLoadingTable(false);
      setTodayLoadingTable(false);
      setQueuedLoadingTable(false);
    }
  };

  const updateOrderStatus = (status) => {
    const newOrder = produce(orderDetail, (draftState) => {
      draftState.status = status;
    });
    handleOrderDetail(newOrder);
  };

  const initialFetch = useCallback(
    async (page = 1, filtersRef) => {
      await dispatch(getAllBranches(null, true));

      const [response] = await Promise.all([
        dispatch(getMonitorOrders(user.branch, user.admin, page, filtersRef)),
        dispatch(getOrderStats(user.branch, user.admin)),
        dispatch(cancellationReasonListThunk()),
      ]);

      if (response.status === "success") {
        const totalItems = response.total || 0;
        const lastPage = Math.ceil(totalItems / 10);
        filtersRef.current.total = totalItems;

        if (page > lastPage && lastPage > 0) {
          setCurrentPage(lastPage);
          filtersRef.current.current = lastPage;
          await initialFetch(lastPage, filtersRef); // reintenta con la última válida
          return;
        }

        setOrdersTotal(totalItems);
      } else {
        message.error("Hubo un problema");
      }
    },
    [dispatch, user]
  );

  const openDetails = async (order) => {
    handleLoadingOrder(order);
    const response = await dispatch(getOrderDetails(order));
    handleLoadingOrder(false);
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      handleOrderDetail(response.order);
      handleModalOrder(true);
    }
  };

  const closeDetails = () => {
    handleModalOrder(false);
    handleOrderDetail({});
  };

  const acceptOrder = async () => {
    const response = await dispatch(
      acceptMonitorOrder(orderDetail.id, user.branch)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(7);
      message.success("Orden en preparación");
    }
  };

  const updateOrder = async () => {
    if (orderDetail.orderType === 2) {
      const response = await dispatch(dispatchMonitorOrder(orderDetail.id));
      if (response.status !== "success") {
        message.error("Hubo un problema");
      } else {
        updateOrderStatus(10);
        message.success("Orden lista para el driver");
      }
    } else {
      const response = await dispatch(updateMonitorOrder(orderDetail.id));
      if (response.status !== "success") {
        message.error("Hubo un problema");
      } else {
        updateOrderStatus(11);
        message.success("Orden lista para recoger");
      }
    }
  };

  const assignOrder = async (driver, force) => {
    let response = null;
    if (force) {
      response = await dispatch(
        assignMonitorDriver(orderDetail.id, driver, force)
      );
    } else {
      response = await dispatch(assignMonitorDriver(orderDetail.id, driver));
    }

    console.log("asignado y respuesta");
    if (response.status !== "success") {
      if (response.status === "warning") {
        Modal.confirm({
          title: "Cambio de driver detectado",
          content: `¿Deseas cambiar el driver actual ${response.driver.name}?`,
          okText: "Confirmar",
          cancelText: "Cancelar",
          onOk: () => assignOrder(driver, true), // llamada con forzarCambio = true
        });
      } else {
        message.error("Hubo un problema");
      }
    } else {
      //handleOrderDetail(response.order);
      //await initialFetch();
      //updateOrderStatus(10);
      handleOrderDetail(response.order);
      message.success("Orden asignada");
    }
  };

  const transferOrder = async (branch, reason) => {
    const response = await dispatch(
      transferMonitorOrder(orderDetail.id, branch, user.id, reason)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(7);
      message.success("Orden transferida");
    }
  };

  const finishOrder = async () => {
    const response = await dispatch(finishMonitorOrder(orderDetail.id));
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(12);
      message.success("Orden finalizada");
      closeDetails(); // cerrar modal
      getActiveOrders({ user: user.id, isAdmin, current: currentPage, pageSize: pageSize, filters: tableFilters });
    }
  };

  const cancelOrder = async (user, reason) => {
    const response = await dispatch(
      cancelMonitorOrder(orderDetail.id, user, reason)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(15);
      message.success("Orden cancelada");
      closeDetails();
      getActiveOrders({ user: user.id, isAdmin, current: currentPage, pageSize: pageSize, filters: tableFilters });
    }
  };

  const resendOrder = async () => {
    const response = await dispatch(
      resendCirebaOrder(orderDetail.id, orderDetail.branch.id)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      message.success("Orden enviada hacia Punto de Venta");
      // closeModalCommetaries();
    }
  };

  const sendPeya = async () => {
    message.info("Enviando Solicitud a pedidos ya");
    const response = await dispatch(
      sendPeyaOrder(orderDetail.id, orderDetail.branch.id)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      message.success("Orden enviada a Pedidos Ya");
      // closeModalCommetaries();
    }
  };
  const getDriversBranch = async (location, order) => {
    const response = await dispatch(getBranchDrivers(location, order));
    if (response.status !== "success") {
      message.error("Hubo un problema");
      return [];
    }
    return response.drivers;
  };

  const updateManualRemoteId = async (remoteId) => {
    const response = await dispatch(updateCirebaRemoteId(orderDetail.id, remoteId));
    if (response.status !== "success") {
      message.error(response.message || "Hubo un problema");
    } else {
      handleOrderDetail(response.order);
      message.success("ID de Cireba actualizado");
    }
  };

  const openDriverConfirm = (order) => {
    handleModalDriverConfirm(true);
  };

  const tabsItems = [
    {
      key: "1",
      label: "TOTAL ÓRDENES ACTIVAS",
      children: (
        <TotalActiveOrders
          activeOrders={activeOrders}
          getActiveOrders={getActiveOrders}
          openDetails={openDetails}
          loadingOrder={loadingOrder}
          loadingTable={loadingTable}
          filtersRef={filtersRef}
          currentPage={currentPage}
          pageSize={pageSize}
          tableFilters={tableFilters}
          onSearchApply={() => {
            const parsedFilters = {
              ...tableFilters,
              branch_name: filtersRef.current?.branch_name,
              ticket: filtersRef.current?.ticket,
              id_user__name: filtersRef.current?.id_user__name,
              id_user__mobile: filtersRef.current?.id_user__mobile,
              platformName: filtersRef.current?.platformName,
            };
            setTableFilters(parsedFilters);
            setLoadingTable(true);
            getActiveOrders({
              user: user.id,
              isAdmin,
              current: currentPage,
              pageSize: pageSize,
              filters: parsedFilters,
            }).finally(() => setLoadingTable(false));
          }}
          onTableChange={(pagination, filters) => {
            const newPageSize = pagination.pageSize;
            const page = newPageSize !== pageSize ? 1 : pagination.current;

            // Captura de filtros: del Table (status, orderType) y de búsqueda (filtersRef)
            const parsedFilters = {
              status: filters.status?.[0],
              orderType: filters.orderTypeName?.[0],
              branch_name: filtersRef.current?.branch_name,
              ticket: filtersRef.current?.ticket,
              id_user__name: filtersRef.current?.id_user__name,
              id_user__mobile: filtersRef.current?.id_user__mobile,
              platformName: filtersRef.current?.platformName,
            };

            setCurrentPage(page);
            setPageSize(newPageSize);
            setTableFilters(parsedFilters);
            setLoadingTable(true);
            getActiveOrders({
              user: user.id,
              isAdmin,
              current: page,
              pageSize: newPageSize,
              filters: parsedFilters,
            }).finally(() => setLoadingTable(false));
          }}
        />
      ),
      amount: activeOrders?.total || 0,
    },
    {
      key: "2",
      label: "TIEMPO DE ÓRDENES ENTREGADAS EN TURNO",
      children: (
        <OrderDeliveryTimeInShift
          todayOrders={todayOrders}
          getTodayOrders={getTodayOrders}
          loadingTable={todayLoadingTable}
          filtersRef={todayFiltersRef}
          currentPage={todayCurrentPage}
          pageSize={todayPageSize}
          tableFilters={todayTableFilters}
          onSearchApply={() => {
            const parsedFilters = {
              ...todayTableFilters,
              ticket: todayFiltersRef.current?.ticket,
            };
            setTodayTableFilters(parsedFilters);
            setTodayLoadingTable(true);
            getTodayOrders({
              user: user.id,
              isAdmin,
              current: todayCurrentPage,
              pageSize: todayPageSize,
              filters: parsedFilters,
            }).finally(() => setTodayLoadingTable(false));
          }}
          onTableChange={(pagination, filters) => {
            const newPageSize = pagination.pageSize;
            const page = newPageSize !== todayPageSize ? 1 : pagination.current;
            const parsedFilters = {
              tipo_orden: filters.tipo_orden?.[0],
              ticket: todayFiltersRef.current?.ticket,
            };
            setTodayCurrentPage(page);
            setTodayPageSize(newPageSize);
            setTodayTableFilters(parsedFilters);
            setTodayLoadingTable(true);
            getTodayOrders({
              user: user.id,
              isAdmin,
              current: page,
              pageSize: newPageSize,
              filters: parsedFilters,
            }).finally(() => setTodayLoadingTable(false));
          }}
        />
      ),
      amount: todayOrders?.total || 0,
    },
    {
      key: "3",
      label: "ENCOLADO DE ÓRDENES",
      children: (
        <OrderGluing
          queuedOrders={queuedOrders}
          getQueuedOrders={getQueuedOrders}
          loadingTable={queuedLoadingTable}
          filtersRef={queuedFiltersRef}
          currentPage={queuedCurrentPage}
          pageSize={queuedPageSize}
          tableFilters={queuedTableFilters}
          onSearchApply={() => {
            const parsedFilters = {
              ...queuedTableFilters,
              ticket: queuedFiltersRef.current?.ticket,
              cliente: queuedFiltersRef.current?.cliente,
              telefono: queuedFiltersRef.current?.telefono,
              sucursal: queuedFiltersRef.current?.sucursal,
            };
            setQueuedTableFilters(parsedFilters);
            setQueuedLoadingTable(true);
            getQueuedOrders({
              user: user.id,
              isAdmin,
              current: queuedCurrentPage,
              pageSize: queuedPageSize,
              filters: parsedFilters,
            }).finally(() => setQueuedLoadingTable(false));
          }}
          onTableChange={(pagination, filters) => {
            const newPageSize = pagination.pageSize;
            const page = newPageSize !== queuedPageSize ? 1 : pagination.current;
            const parsedFilters = {
              tipo_orden: filters.tipo_orden?.[0],
              ticket: queuedFiltersRef.current?.ticket,
              cliente: queuedFiltersRef.current?.cliente,
              telefono: queuedFiltersRef.current?.telefono,
              sucursal: queuedFiltersRef.current?.sucursal,
            };
            setQueuedCurrentPage(page);
            setQueuedPageSize(newPageSize);
            setQueuedTableFilters(parsedFilters);
            setQueuedLoadingTable(true);
            getQueuedOrders({
              user: user.id,
              isAdmin,
              current: page,
              pageSize: newPageSize,
              filters: parsedFilters,
            }).finally(() => setQueuedLoadingTable(false));
          }}
        />
      ),
      amount: queuedOrders?.total || 0,
    },
  ];

  return (
    <div>
      <HeaderList
        actions={
          <div className={styles.ordersButtons}>
            <Link to="/drivers" className={styles.history}>
              <span> 📡 DRIVERS EN LINEA</span>
            </Link>

            {/* TODO: control de efectivo de drivers
            <Link to="efectivo-sin-recibir" className={styles.history}>
              <span>EFECTIVO SIN RECIBIR</span>
              <span
                style={{
                  position: "static",
                  transform: "translate(0)",
                  color: "#FFF",
                }}
                className={styles.tabBadge}
              >
                4
              </span>
            </Link>
            */}

            <Link to="/historial" className={styles.history}>
              <History />
              <span>VER HISTORIAL DE ORDENES</span>
            </Link>
          </div>
        }
        title="Órdenes ACTIVAS"
      />
      <Tabs activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
        {tabsItems.map((item) => (
          <Tabs.TabPane
            tab={
              <span className={styles.tabName}>
                {item.label}{" "}
                <span
                  style={{
                    backgroundColor:
                      activeKey === item.key ? "var(--orange)" : "#949494",
                  }}
                  className={styles.tabBadge}
                >
                  {item.amount}
                </span>
              </span>
            }
            key={item.key}
          >
            {item.children}
          </Tabs.TabPane>
        ))}
      </Tabs>

      <Drawer
        destroyOnClose
        placement="right"
        visible={modalOrder}
        width={1150}
        closable={true}
        onClose={closeDetails}
        className={styles.modalOrder}
      >
        {orderDetail && (
          <OrderDetail
            order={orderDetail}
            monitor
            branches={branches}
            acceptOrder={acceptOrder}
            updateOrder={updateOrder}
            assignOrder={assignOrder}
            finishOrder={finishOrder}
            cancelOrder={cancelOrder}
            resendOrder={resendOrder}
            sendPeya={sendPeya}
            getDriversBranch={getDriversBranch}
            openDriverConfirm={openDriverConfirm}
            transferOrder={transferOrder}
            reasons={reasons}
            updateManualRemoteId={updateManualRemoteId}
          />
        )}
      </Drawer>
    </div>
  );
};

export default ActiveOrdersMonitorUI;
